import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fetchData, fetchAllData } from "../../helpers/externapi";
import { MultiSelect } from "react-multi-select-component";
import CircularProgress from '@mui/material/CircularProgress';
import 'jspdf-autotable';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { downloadCSVData, downloadExcelData, constructCompleteAddress, formatDate, fetchConfigValues } from '../../Commoncomponents/CommonComponents';
import CommonTables from '../../Commoncomponents/CommonTables';
import moment from 'moment';
import Modal from 'react-modal';
import { TableSkeletonLoading } from "../../Commoncomponents/SkeletonLoading";
import DescriptionCell from "../../Commoncomponents/DescriptionCell";

export default function RenewalList({ activeTab }) {
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [error, setError] = useState('');
    const [tableloading, setTableLoading] = useState(false);
    const [membersData, setMembersData] = useState([]);
    const [selectedStates, setSelectedStates] = useState([]);
    const [statesMultiSelect, setStatesMultiSelect] = useState();
    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [districtsMultiSelect, setDistricsMultiSelect] = useState();
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [filterCriteria, setFilterCriteria] = useState([]);
    const [selectedNames, setSelectedNames] = useState([]);
    const [selectedSearch, setSelectedSearch] = useState([]);
    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const [selectedMandals, setSelectedMandals] = useState([]);
    const [selectedVillages, setSelectedVillages] = useState([]);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [rmOptions, setRmOptions] = useState([]);
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRegionalManager, setSelectedRegionalManager] = useState('');
    const [selectedRouteMap, setSelectedRouteMap] = useState('');
    const [callResponseOptions, setCallResponseOptions] = useState([]);
    const [selectedResponse, setSelectedResponse] = useState([]);
    const [livelongStatusFilter, setLivelongStatusFilter] = useState([]);
    const [paStatusFilter, setPaStatusFilter] = useState([]);
    const [input, setInput] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const tomorrow = new Date();
    const navigate = useNavigate();
    const [callLogMemberId, setCallLogMemberId] = useState();
    const [callHistory, setCallHistory] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [callResponseFilter, setCallResponseFilter] = useState([]);
    const initialFormData = {
        callHistoryId: "", callLog: "", CardNumber: "", CollectedDate: "",
        callResponsesId: "", RMName: "", DateToBeVisited: "", RequestCallBack: ""
    };
    const [formData, setFormData] = useState(initialFormData);
    const [formError, setFormError] = useState({});
    const [isFormVisable, setIsFormVisible] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [isDisableApply, setIsDisableApply] = useState(true);
    const [serviceStatus, setServiceStatus] = useState([]);
    const [memberTypes, setMemberTypes] = useState([]);
    const [memberTypeId, setMemberTypeId] = useState();
    const [selectedView, setSelectedView] = useState();
    const [mocLoading, setMocLoading] = useState(false);
    const [mocError, setMocError] = useState('');
    const [mocSuccess, setMocSuccess] = useState('');
    const [mocUrl, setMocUrl] = useState();
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [isCustomers, setIsCustomers] = useState(false);
    const [isActiveCustomers, setIsActiveCustomers] = useState(true);
    const [isAssignedHovered, setIsAssignedHovered] = useState(false);
    const [isUnAssignedHovered, setIsUnAssignedHovered] = useState(false);

    let UserId = localStorage.getItem("UserId");

    const thresholdDays = 5;
    const tableHeads = ["FULL NAME", "CALL HISTORY", "Call Response", "Card Number", "REGISTERED DATE", "Product Name", "Sale Done By"];

    const responseLabels = {
        "Welcome Call": "bg-label-success",
        "Interested": "bg-label-info",
        "Busy Call back": "bg-label-warning",
        "Pipeline": "bg-label-secondary",
        "Not Interested": "bg-label-danger",
        "Not Available": "bg-label-dark",
        "Requested CallBack": "bg-label-primary"
    };

    // ─── Determine which API endpoint to use based on activeTab ───────────────
    const getApiEndpoint = () => {
        return activeTab === "completed"
            ? "lambdaAPI/Customer/CustomersRenewalCallsCompleted"
            : "lambdaAPI/Customer/CustomersRenewalCallsNotCompleted";
    };

    // ─── Separate count API endpoints based on activeTab ─────────────────────
    const getCountApiEndpoint = () => {
        return activeTab === "completed"
            ? "lambdaAPI/Customer/GetCustomersRenewalCallsCompletedCount"
            : "lambdaAPI/Customer/GetCustomersRenewalCallsNotCompletedCount";
    };

    const getExcelApiKey = () => {
        return activeTab === "completed"
            ? "customersrenewalcallscompleted"
            : "customersrenewalcallsnotcompleted";
    };

    // ─── Reset page and data when tab changes ─────────────────────────────────
    useEffect(() => {
        setCurrentPage(1);
        setFilterCriteria([]);
        setMembersData([]);
        setIsDataLoaded(false);
        setTotalCount(0);
    }, [activeTab]);

    // ─── Fetch total count using the dedicated count endpoint ─────────────────
    const getDistributorCountData = async () => {
        setLoading(true);
        try {
            const countEndpoint = getCountApiEndpoint();
            const response = await fetchAllData(countEndpoint);
            const count = Array.isArray(response)
                ? (response[0]?.countOfRecords ?? 0)
                : (response?.countOfRecords ?? 0);
            setTotalCount(count);
        } catch (error) {
            console.error("Error fetching count:", error);
        } finally {
            setLoading(false);
        }
    };

    // ─── Fetch only paginated data ────────────────────────────────────────────
    const getDistributorData = async () => {
        setLoading(true);
        try {
            const skip = (currentPage - 1) * perPage;
            const take = perPage;

            if (filterCriteria.length > 0) {
                const responsePayload = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", {
                    skip, take, filter: filterCriteria
                });
                const dataArray = Array.isArray(responsePayload)
                    ? responsePayload
                    : (responsePayload?.data || []);
                setMembersData(dataArray.map(d => ({ ...d, completeAddress: constructCompleteAddress(d) })));
            } else {
                const endpoint = getApiEndpoint();
                // Data endpoints return array directly (not wrapped in { data: [...] })
                const responsePayload = await fetchData(endpoint, { skip, take });
                const dataArray = Array.isArray(responsePayload)
                    ? responsePayload
                    : (responsePayload?.data || []);
                setMembersData(dataArray.map(d => ({ ...d, completeAddress: constructCompleteAddress(d) })));
            }

            setIsDataLoaded(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleMocView = (data) => {
        setSelectedView(data);
        setMocError('');
        setMocSuccess('');
    };

    const tableElements = membersData && membersData.length > 0
        ? membersData.map((data) => ([
            <Link
                to={`/customers/details/${data.CustomerId}`}
                className="text-start-important"
                style={{ whiteSpace: 'normal', textAlign: 'start', display: 'block' }}
            >
                {data.Name}
            </Link>,
            <button
                style={{ border: '0px', backgroundColor: 'white' }}
                type="button"
                onClick={() => handleCallLog(data.CustomerId)}
            >
                <Link>Call log Data</Link>
            </button>,

            <div>
                <span className={`badge ${responseLabels[data.ResponseName] || 'bg-label-secondary'}`}>
                    {data.ResponseName}
                </span>
                <p>{data.CallLog}</p>
            </div>,

            <div className="text-center">
                {data?.CardNumber
                    ? <p>{data.CardNumber}</p>
                    : <p style={{ color: 'red' }}>No card exists</p>}
            </div>,
            <p className="text-center">
                {data.RegisterOn ? formatDate(data.RegisterOn).slice(0, 11) : ""}
            </p>,
            <div className="text-center">
                {data?.ProductName
                    ? <DescriptionCell description={data.ProductName} />
                    : <p style={{ color: 'red' }}>No Product Purchase</p>}
            </div>,
            <div className="text-center">
                {data?.SaleDoneBy
                    ? <p>{data.SaleDoneBy}</p>
                    : <p style={{ color: 'red' }}>Not exists</p>}
            </div>,
        ]))
        : [];

    const handleCallLog = (memberId) => {
        setCallLogMemberId(memberId);
        setIsModalOpen(true);
    };

    const handleGeneratePolicy = async (order) => {
        try {
            const response = await fetchData("lambdaAPI/HHL/HHLPolicyCreation", {
                ProductsId: order.ProductsId,
                MemberId: order.CustomerId,
                CustomerOrderId: order.CustomerOrderId,
                MemberProductId: order.MemberProductId,
                UserId: UserId
            });
            setSnackbarMessage(response.message);
            setSnackbarOpen(true);
        } catch (error) {
            console.error("Error generating policy:", error);
            alert("An error occurred while generating the policy.");
        }
    };

    // ─── Initial setup effects ────────────────────────────────────────────────
    useEffect(() => {
        const fetchServiceStatus = async () => {
            setLoading(true);
            const response = await fetchData("ServiceStatus/all", { skip: 0, take: 0 });
            setServiceStatus(response);
            setLoading(false);
        };
        fetchServiceStatus();
    }, []);

    useEffect(() => {
        const fetchCallResponseOptions = async () => {
            setLoading(true);
            try {
                const getResponseTypes = await fetchData('CallResponseType/all', { skip: 0, take: 0 });
                const CallResponseTypeId = getResponseTypes.filter(t => t.ResponseName === "Member");
                const response = await fetchAllData(`CallResponse/GetCallResponsesByResponseType/${CallResponseTypeId[0].CallResponseTypeId}`);
                setCallResponseOptions(response);
            } catch (error) {
                console.error("Error fetching call responses:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCallResponseOptions();
    }, []);

    const fetchCallHistoryData = async () => {
        setLoading(true);
        try {
            const response = await fetchAllData(`lambdaAPI/CallHistory/GetAllCallHistoryByCustomerId/${callLogMemberId}`);
            setCallHistory(response);
        } catch (error) {
            console.error('Error fetching call history:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (callLogMemberId) fetchCallHistoryData();
    }, [callLogMemberId]);

    tomorrow.setDate(tomorrow.getDate() + 1);

    const onChangeHandler = (event) => {
        const { name, value, type, checked } = event.target;
        let updatedFormData = { ...formData, [name]: type === 'checkbox' ? (checked ? value : '') : value };
        if (name === 'DateToBeVisited' && value.length === 10) {
            updatedFormData = { ...updatedFormData, DateToBeVisited: `${value}T00:00:00` };
        }
        setFormData(updatedFormData);
        setFormError({ ...formError, [name]: '' });
    };

    useEffect(() => {
        setIsFormValid(formData.callResponsesId.length > 0);
    }, [formData]);

    const handleResetForm = () => {
        setFormData(initialFormData);
        setFormError({});
    };

    const handleBackToView = () => {
        setIsFormVisible(false);
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            const requestData = {
                callLog: formData.callLog,
                CustomerId: callLogMemberId,
                UserId: UserId,
                callResponsesId: formData.callResponsesId,
                DateToBeVisited: formData.DateToBeVisited === "" ? null : formData.DateToBeVisited,
                RequestCallBack: formData.RequestCallBack === "" ? null : formData.RequestCallBack,
            };
            const CallHistoryData = await fetchData('lambdaAPI/CallHistory/add', requestData);
            if (CallHistoryData.status === true) {
                setSnackbarMessage("New call log added successfully!");
                setCallHistory(CallHistoryData);
            } else {
                setSnackbarMessage(`${CallHistoryData.data}`);
            }
            setSnackbarOpen(true);
            await fetchCallHistoryData();
        } catch (error) {
            console.error("Error adding call log:", error);
        } finally {
            setLoading(false);
            setIsFormVisible(false);
            setFormData(initialFormData);
        }
    };

    const handleSnackbarClose = () => setSnackbarOpen(false);

    const handleMandalSelect = (event) => {
        const v = event.target.value;
        if (v === '') setSelectedMandals([]);
        else setSelectedMandals([...selectedMandals, v]);
    };

    const handleVillageSelect = (event) => {
        const v = event.target.value;
        if (v === '') setSelectedVillages([]);
        else setSelectedVillages([...selectedVillages, v]);
    };

    // ─── Count + data fetch triggered by tab change ───────────────────────────
    useEffect(() => {
        getDistributorCountData();
    }, [activeTab]);

    // ─── Data fetch triggered by pagination and tab change ────────────────────
    useEffect(() => {
        getDistributorData();
    }, [currentPage, perPage, activeTab]);

    // ─── Excel / CSV download — uses totalCount from dedicated count API ──────
    const handleExcelDownload = async () => {
        setLoading(true);
        await downloadExcelData(
            getExcelApiKey(),
            totalCount,
            perPage,
            currentPage,
            fetchData,
            filterCriteria,
            setLoading
        );
    };

    const handleCSVDownload = async () => {
        setLoading(true);
        await downloadCSVData(
            getExcelApiKey(),
            totalCount,
            perPage,
            currentPage,
            fetchData,
            filterCriteria,
            setLoading
        );
    };

    // ─── States / Districts / Config ──────────────────────────────────────────
    useEffect(() => {
        const getStates = async () => {
            setLoading(true);
            const statesData = await fetchData("States/all", { skip: 0, take: 0 });
            if (statesData && statesData.length > 0) {
                setStatesMultiSelect(statesData.map(item => ({ label: item.StateName, value: item.StateId })));
            }
            setLoading(false);
        };

        const getDistricts = async () => {
            setLoading(true);
            const districtsData = await fetchData("Districts/all", { skip: 0, take: 0 });
            if (districtsData && districtsData.length > 0) {
                setDistricsMultiSelect(districtsData.map(item => ({ label: item.DistrictName, value: item.DistrictId })));
            }
            setLoading(false);
        };

        const fetchMocUrl = async () => {
            const { policiesDownloadURL } = await fetchConfigValues();
            if (policiesDownloadURL) setMocUrl(policiesDownloadURL);
        };

        getStates();
        getDistricts();
        fetchMocUrl();
    }, []);

    useEffect(() => {
        const getRegionalManagers = async () => {
            setLoading(true);
            try {
                const usersData = await fetchAllData(`lambdaAPI/Employee/GetRMNames`);
                setRmOptions(usersData.map(u => ({ label: u.UserName, value: u.UserName })));
            } catch (error) {
                console.error('Error fetching regional managers:', error);
            } finally {
                setLoading(false);
            }
        };
        getRegionalManagers();
    }, []);

    useEffect(() => {
        const fetchCallResponseOptionsFilter = async () => {
            setLoading(true);
            try {
                const response = await fetchData("CallResponse/all", { skip: 0, take: 0 });
                setCallResponseFilter(response.map(item => ({ label: item.ResponseName, value: item.CallResponsesId })));
            } catch (error) {
                console.error("Error fetching call responses:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCallResponseOptionsFilter();
    }, []);

    useEffect(() => {
        const hasFilter = selectedStates.length > 0 || selectedDistricts.length > 0 ||
            selectedResponse.length > 0 || selectedMandals.length > 0 ||
            selectedNames.length > 0 || selectedNumbers.length > 0 ||
            selectedRegionalManager.length > 0 || selectedRouteMap.length > 0 ||
            selectedVillages.length > 0 || livelongStatusFilter.length > 0 || paStatusFilter.length > 0;
        setIsDisableApply(!hasFilter);
    }, [selectedStates, selectedDistricts, selectedResponse, selectedMandals,
        livelongStatusFilter, paStatusFilter, selectedNames, selectedNumbers,
        selectedRegionalManager, selectedRouteMap, selectedVillages]);

    const handleRegionalManagerChange = (v) => setSelectedRegionalManager(v);
    const handleRouteMapChange = (v) => setSelectedRouteMap(v);

    const handleInputChange = async (event) => {
        const value = event.target.value;
        setInput(value);

        if (value.length >= 2) {
            const fc = [];
            if (/^\d+$/.test(value)) {
                fc.push({ key: "MobileNumber", value, operator: "LIKE" });
            } else {
                fc.push({ key: "Name", value, operator: "LIKE" });
            }
            const today = new Date();
            const localDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
            fc.push({ key: "CardEndDate", value: localDate, operator: "<" });

            setSearchLoading(true);
            setError('');
            try {
                const suggestionData = await fetchData("lambdaAPI/Customer/GetCustomerMultipleDataByNameAndMobileNum", {
                    skip: 0, take: perPage, filter: fc
                });
                if (suggestionData.length > 0) {
                    setSuggestions(suggestionData);
                } else {
                    setError('No suggestions found.');
                    setSuggestions([]);
                }
            } catch {
                setError('Failed to fetch suggestions.');
                setSuggestions([]);
            } finally {
                setSearchLoading(false);
            }
        } else {
            setSuggestions([]);
        }
    };

    const handleSuggestionClick = (suggestion) => {
        navigate(`/customers/details/${suggestion.MemberId}`);
    };

    const clearSearch = () => {
        setInput('');
        setSuggestions([]);
        setSelectedSearch([]);
    };

    const handleLivelongStatusChange = (v) => setLivelongStatusFilter(v);
    const handlePaStatusChange = (v) => setPaStatusFilter(v);

    const applyFilter = async (memberTypeId = '') => {
        setLoading(true);
        const selectedStateIds = selectedStates.map(s => s.value);
        const selectedDistrictIds = selectedDistricts.map(d => d.value);
        const village = document.getElementById("village-input").value;
        const mandal = document.getElementById("mandal-input").value;
        const selectedResponseId = selectedResponse.join(",");

        const fc = [];

        if (selectedStateIds.length > 0) fc.push({ key: "StateId", value: selectedStateIds.join(","), operator: "IN" });
        if (selectedDistrictIds.length > 0) fc.push({ key: "DistrictId", value: selectedDistrictIds.join(","), operator: "IN" });
        if (selectedRegionalManager.length > 0) fc.push({ key: "SaleDoneBy", value: selectedRegionalManager, operator: "LIKE" });
        if (selectedRouteMap.length > 0) fc.push({ key: "RouteName", value: selectedRouteMap, operator: "LIKE" });
        if (mandal.trim() !== "") fc.push({ key: "Mandal", value: mandal, operator: "LIKE" });
        if (village.trim() !== "") fc.push({ key: "Village", value: village, operator: "LIKE" });
        if (memberTypeId.length > 0) fc.push({ key: "MemberTypeId", value: memberTypeId, operator: "IN" });
        if (selectedResponseId.length > 0) fc.push({ key: "CallResponsesId", value: selectedResponseId, operator: "IN" });
        if (livelongStatusFilter && livelongStatusFilter.length > 0) {
            if (livelongStatusFilter === 1) {
                fc.push({ key: "ServiceProviderStatusId", value: "null", operator: 'IS', groupOperator: "OR" });
                fc.push({ key: "ServiceProviderStatusId", value: "1", operator: 'IN' });
            } else {
                fc.push({ key: "ServiceProviderStatusId", value: livelongStatusFilter, operator: 'LIKE' });
            }
        }
        if (paStatusFilter && paStatusFilter.length > 0) {
            if (paStatusFilter === 1) {
                fc.push({ key: "PersonalAccidentStatusId", value: "null", operator: 'IS', groupOperator: "OR" });
                fc.push({ key: "PersonalAccidentStatusId", value: "1", operator: 'IN' });
            } else {
                fc.push({ key: "PersonalAccidentStatusId", value: paStatusFilter, operator: 'LIKE' });
            }
        }

        const today = new Date();
        const localDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
        fc.push({ key: "CardEndDate", value: localDate, operator: "<" });

        try {
            const countData = await fetchData(`lambdaAPI/Customer/FetchCustomerListFilterCount`, { filter: fc });
            setTotalCount(countData[0]?.customerListCount || 0);

            const filterData = await fetchData("lambdaAPI/Customer/GetMultipleDataByFilter", {
                skip: 0,
                take: perPage,
                filter: fc
            });
            setPerPage(perPage);
            setCurrentPage(1);
            setMembersData((Array.isArray(filterData) ? filterData : filterData?.data || []).map(m => ({
                ...m,
                MobileNumber: m.MobileNumber
            })));
            setFilterCriteria(fc);
        } catch (error) {
            console.error("Error applying filter:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleCallResponseChange = (event) => {
        const value = parseInt(event.target.value);
        if (selectedResponse.includes(value)) {
            setSelectedResponse(selectedResponse.filter(v => v !== value));
        } else {
            setSelectedResponse([...selectedResponse, value]);
        }
    };

    // ─── Clear filters and re-fetch count from dedicated count API ────────────
    const clearFilters = async () => {
        setSelectedStates([]);
        setSelectedDistricts([]);
        setSelectedMandals([]);
        setSelectedVillages([]);
        setSelectedRegionalManager([]);
        setSelectedRouteMap([]);
        setSelectedResponse([]);
        setIsDisableApply(true);
        setLivelongStatusFilter('');
        setPaStatusFilter('');
        document.getElementById("village-input").value = "";
        document.getElementById("mandal-input").value = "";
        setFilterCriteria([]);
        await getDistributorCountData();   // uses dedicated count endpoint
        await getDistributorData();
    };

    const handlePageChange = (event, page) => setCurrentPage(page);
    const handlePerPageChange = (event) => {
        setPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1);
    };

    const downloadMOC = async () => {
        const endUrl = selectedView.MembershipCertificate;
        if (mocUrl && mocUrl.length > 0) {
            const link = document.createElement('a');
            link.href = `${mocUrl + endUrl}`;
            link.download = endUrl;
            link.target = '_blank';
            link.click();
            setMocError('');
        } else {
            setMocError('Something went wrong. Please Contact Technical Team');
        }
    };

    const generateMOC = async () => {
        setMocLoading(true);
        const response = await fetchData('PaymentDetails/policygeneration', {
            productsId: selectedView.ProductId,
            MemberId: selectedView.MemberId,
            MemberProductId: selectedView.MemberProductId
        });
        setMocLoading(false);
        if (!response || response === undefined) {
            setMocError('Something went wrong, Please Contact Technical Team');
            setMocSuccess('');
        } else if (response.status) {
            setMocSuccess('MOC generated successfully');
            const link = document.createElement('a');
            link.href = `${mocUrl + response.data}`;
            link.download = response.data;
            link.target = '_blank';
            link.click();
            setMocError('');
        }
    };

    const fetchUnassignedCardCustomers = async (id) => {
        setLoading(true);
        try {
            const unassignedCount = await fetchAllData('Member/FetchUnAssginedCardCustomerListCount');
            const response = await fetchData('Member/FetchUnAssginedCardCustomerList', {
                skip: 0, take: perPage, membertypeid: id
            });
            setTotalCount(unassignedCount[0].customerListCount);
            setMembersData(response);
        } catch (error) {
            console.error("Error fetching unassigned card customers:", error);
        } finally {
            setLoading(false);
        }
    };

    const showCallLog = () => (
        callHistory && callHistory.length > 0 ? (
            <div className="row">
                <div className="card col-12 col-md-6 card-action mb-4">
                    <div className="card-header align-items-center">
                        <h5 className="card-action-title mb-0">
                            <i className="bx bx-list-ul me-2"></i>Call History
                        </h5>
                    </div>
                    <div className="card-body">
                        <ul className="timeline ms-2">
                            {callHistory.map((call, index) => (
                                <li key={index} className="timeline-item timeline-item-transparent">
                                    <span className="timeline-point-wrapper">
                                        <span className="timeline-point timeline-point-success"></span>
                                    </span>
                                    <div className="timeline-event">
                                        <div className="timeline-header mb-1">
                                            <h6 className="mb-0">
                                                {call.UserName}
                                                <span className="badge bg-label-primary mb-2">{call.CallResponseName}</span>
                                            </h6>
                                            <small className="text-muted">
                                                {moment(call.CollectedDate).local().diff(moment(), 'days') <= thresholdDays
                                                    ? <strong>{moment(call.CollectedDate).local().fromNow()}</strong>
                                                    : <strong>{moment(call.CollectedDate).local().format('DD-MMM-YYYY h:mm A')}</strong>}
                                            </small>
                                        </div>
                                        <div className="timeline-header mb-1 mt-1">
                                            <h6 className="mb-0">Remarks :</h6>
                                        </div>
                                        <p className="mb-0">{call.CallLog}</p>
                                        {call.DateToBeVisited !== '0001-01-01T00:00:00' && (
                                            <>
                                                <div className="timeline-header mb-1 mt-1">
                                                    <h6 className="mb-0">Requested RM to visit on :</h6>
                                                </div>
                                                <p className="mb-0">{moment(call.DateToBeVisited).local().format('DD-MMM-YYYY h:mm A')}</p>
                                            </>
                                        )}
                                        {call.RequestCallBack !== '0001-01-01T00:00:00' && (
                                            <>
                                                <div className="timeline-header mb-1 mt-1">
                                                    <h6 className="mb-0">Requested Callback on :</h6>
                                                </div>
                                                <p className="mb-0">{moment(call.RequestCallBack).local().format('DD-MMM-YYYY h:mm A')}</p>
                                            </>
                                        )}
                                    </div>
                                </li>
                            ))}
                            <li className="timeline-end-indicator">
                                <i className="bx bx-check-circle"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-12 col-md-6">
                    <button className="btn btn-primary btn-md mb-4" onClick={() => setIsFormVisible(true)}>
                        Add New Call Log
                    </button>
                    {isFormVisable && addCallLogForm()}
                </div>
            </div>
        ) : (
            <div className="row">
                <div className="text-danger fw-semibold col-12 col-md-5 mb-4 mx-2">
                    No Call History records
                </div>
                <div className="col-12 col-md-6">
                    <button className="btn btn-primary btn-md mb-4" onClick={() => setIsFormVisible(true)}>
                        Add New Call Log
                    </button>
                    {isFormVisable && addCallLogForm()}
                </div>
            </div>
        )
    );

    const addCallLogForm = () => (
        <form onSubmit={onSubmitHandler} className="p-4 border rounded shadow-sm bg-white mb-4">
            <div className="mb-4">
                <h5 className="mb-3" style={{ fontWeight: 'bold' }}>
                    Call Response <span style={{ color: "red" }}> *</span>
                </h5>
                <div className="d-flex flex-wrap">
                    {callResponseOptions.map((option) => (
                        <div className="form-check me-4 mb-2 col-5" key={option.CallResponsesId}>
                            <input
                                className="form-check-input"
                                type="radio"
                                id={`callResponse_${option.CallResponsesId}`}
                                name="callResponsesId"
                                value={option.CallResponsesId}
                                checked={formData.callResponsesId.includes(option.CallResponsesId)}
                                onChange={onChangeHandler}
                            />
                            <label className="form-check-label" htmlFor={`callResponse_${option.CallResponsesId}`}>
                                {option.ResponseName}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-sm-6">
                    <div className="mb-3">
                        <label htmlFor="DateToBeVisited" className="form-label">Date To Be Visited</label>
                        <input type="datetime-local" className="form-control" id="DateToBeVisited"
                            name="DateToBeVisited" value={formData.DateToBeVisited} onChange={onChangeHandler} />
                    </div>
                </div>
                <div className="col-12 col-sm-6">
                    <div className="mb-3">
                        <label htmlFor="RequestCallBack" className="form-label">Request Call Back</label>
                        <input type="datetime-local" className="form-control" id="RequestCallBack"
                            name="RequestCallBack" value={formData.RequestCallBack} onChange={onChangeHandler} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="mb-3">
                        <label htmlFor="remarks" className="form-label">Remarks</label>
                        <textarea className="form-control" id="remarks" name="callLog"
                            placeholder="Enter Remarks" onChange={onChangeHandler}
                            value={formData.callLog} rows="4" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 d-flex justify-content-start">
                    <button type="submit" className="btn btn-primary" disabled={!isFormValid}>Submit</button>
                    <button className="btn btn-secondary ms-2" type="button" onClick={handleResetForm}>Reset</button>
                    <button className="btn btn-danger ms-2" type="button" onClick={handleBackToView}>Cancel</button>
                </div>
            </div>
        </form>
    );

    const selectedCallResponseLabels = Array.isArray(selectedResponse)
        ? selectedResponse
            .map(r => callResponseFilter.find(o => o.value === parseInt(r))?.label)
            .filter(Boolean)
            .join(', ')
        : callResponseFilter.find(o => o.value === parseInt(selectedResponse))?.label || "No Call Response selected";

    const SelectedLiveLongStatusLabel = serviceStatus.find(r => r.ServiceStatusId === parseInt(livelongStatusFilter))?.StatusName || "No Status selected";
    const SelectedPAStatusLabel = serviceStatus.find(r => r.ServiceStatusId === parseInt(paStatusFilter))?.StatusName || "No Status selected";

    const filterUI = () => (
        <div className="card p-1 my-1 sticky-top" style={{ zIndex: 1 }}>
            {/* Active filter tags */}
            <div className="select2-primary mx-1 mb-2" style={{ display: 'flex', flexWrap: 'wrap' }}>
                {(selectedNames.length > 0 || selectedNumbers.length > 0 || selectedStates.length > 0 ||
                    selectedDistricts.length > 0 || selectedMandals.length > 0 || selectedVillages.length > 0 ||
                    selectedRegionalManager.length > 0 || selectedRouteMap.length > 0 ||
                    selectedResponse.length > 0 || livelongStatusFilter.length > 0 || paStatusFilter.length > 0) && (
                        <>
                            <strong style={{ marginRight: '5px' }}>Filter Criteria - </strong>
                            {selectedStates.length > 0 && (
                                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ marginRight: '5px' }}>State: </strong>
                                    {selectedStates.map((s, i) => (
                                        <span key={s.value} className="selected-option-button">
                                            {s.label}{i !== selectedStates.length - 1 && ', '}
                                        </span>
                                    ))}
                                </div>
                            )}
                            {selectedDistricts.length > 0 && (
                                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ marginRight: '5px' }}>District: </strong>
                                    {selectedDistricts.map((d, i) => (
                                        <span key={d.value} className="selected-option-button">
                                            {d.label}{i !== selectedDistricts.length - 1 && ', '}
                                        </span>
                                    ))}
                                </div>
                            )}
                            {selectedMandals.length > 0 && (
                                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ marginRight: '5px' }}>Mandal: </strong>
                                    <span className="selected-option-button">{selectedMandals[selectedMandals.length - 1]}</span>
                                </div>
                            )}
                            {selectedVillages.length > 0 && (
                                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ marginRight: '5px' }}>Village: </strong>
                                    <span className="selected-option-button">{selectedVillages[selectedVillages.length - 1]}</span>
                                </div>
                            )}
                            {selectedRegionalManager.length > 0 && (
                                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ marginRight: '5px' }}>Sale Done By: </strong>
                                    <span className="selected-option-button">{selectedRegionalManager}</span>
                                </div>
                            )}
                            {selectedResponse.length > 0 && (
                                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ marginRight: '5px' }}>Call Response: </strong>
                                    <span className="selected-option-button">{selectedCallResponseLabels}</span>
                                </div>
                            )}
                            {livelongStatusFilter.length > 0 && (
                                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ marginRight: '5px' }}>Service Provider Status: </strong>
                                    <span className="selected-option-button">{SelectedLiveLongStatusLabel}</span>
                                </div>
                            )}
                            {paStatusFilter.length > 0 && (
                                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                                    <strong style={{ marginRight: '5px' }}>PA Status: </strong>
                                    <span className="selected-option-button">{SelectedPAStatusLabel}</span>
                                </div>
                            )}
                        </>
                    )}
            </div>

            <div className="row gy-2 align-items-center">
                <div className="col-4 col-md-4">
                    <ul className="nav nav-md nav-pills">
                        <li className="nav-item">
                            <Link className="nav-link" to="/customers/new">
                                <i className="tf-icons navbar-icon bx bx-plus-circle"></i>&nbsp;Add New
                            </Link>
                        </li>
                    </ul>
                </div>

                {/* Search input */}
                <div className="col-12 col-md-4">
                    <div>
                        <label htmlFor="search-input" className="form-label">Name or Mobile Number</label>
                        <div style={{ position: 'relative', maxWidth: '350px' }}>
                            <input
                                type="text"
                                id="search-input"
                                className="form-control"
                                style={{ paddingLeft: '30px' }}
                                maxLength="50"
                                value={input}
                                onChange={handleInputChange}
                            />
                            {input && (
                                <i className="fas fa-times-circle"
                                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '16px', color: 'red', cursor: 'pointer' }}
                                    onClick={clearSearch}
                                />
                            )}
                            {searchLoading && (
                                <div style={{ position: 'absolute', right: '40px', top: '50%', transform: 'translateY(-50%)' }}>
                                    <div className="spinner-border text-primary" role="status" style={{ width: '1.5rem', height: '1.5rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}
                            {input && !searchLoading && suggestions.length > 0 && (
                                <ul style={{
                                    listStyleType: 'none', padding: '0', margin: '0',
                                    border: '1px solid #00796b', borderRadius: '4px',
                                    maxHeight: '200px', overflowY: 'auto',
                                    position: 'absolute', width: '100%',
                                    backgroundColor: '#fff', zIndex: 10, top: '100%', left: '0'
                                }}>
                                    {suggestions.map((suggestion, index) => (
                                        <li key={index} onClick={() => handleSuggestionClick(suggestion)}
                                            style={{ padding: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                            <i className="fas fa-arrow-up-left" style={{ marginRight: '8px', color: '#00796b' }}></i>
                                            <span style={{ flex: 1 }}>{suggestion.Concatenated}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {input && !searchLoading && error && (
                                <div style={{
                                    position: 'absolute', top: '100%', left: '0',
                                    color: 'red', fontSize: '0.9rem', marginTop: '4px',
                                    backgroundColor: '#fff', border: '1px solid #00796b',
                                    borderRadius: '4px', padding: '8px', zIndex: 10, width: '100%'
                                }}>
                                    {error}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Action buttons */}
                <div className="col-12 col-md-4 mt-2 mt-md-0 d-flex flex-row-reverse align-items-center gap-2">
                    <button className="btn btn-sm btn-primary" onClick={handleExcelDownload}>
                        <i className="bx bx-export me-sm-1"></i>
                        <span className="d-none d-sm-inline-block"> Excel</span>
                    </button>
                    <button className="btn btn-sm btn-success" onClick={handleCSVDownload}>
                        <i className="bx bx-export me-sm-1"></i>
                        <span className="d-none d-sm-inline-block"> CSV</span>
                    </button>
                    <button type="button" className="btn btn-sm btn-primary"
                        data-bs-toggle="modal" data-bs-target="#filterModal">
                        <i className="fas fa-filter" style={{ marginRight: '5px' }}></i>
                        <span className="d-none d-sm-inline-block"> Filters</span>
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <>
            {loading ? <TableSkeletonLoading /> : !isDataLoaded ? <TableSkeletonLoading /> : (
                <>
                    {filterUI()}

                    <div className="accordion" id="accordionExample">

                        {/* Filter Modal */}
                        <div className="modal fade" id="filterModal" tabIndex="-1" aria-labelledby="filterModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="filterModalLabel">Filters</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="accordion-body">
                                            <div className="row mb-2">
                                                <div className="col-lg-8 order-1 order-md-0">
                                                    <label className="form-label">States</label>
                                                    <div className="select2-primary">
                                                        {statesMultiSelect && (
                                                            <MultiSelect options={statesMultiSelect} value={selectedStates} onChange={setSelectedStates} />
                                                        )}
                                                    </div>

                                                    <label className="form-label mt-2">Districts</label>
                                                    <div className="select2-primary">
                                                        {districtsMultiSelect && (
                                                            <MultiSelect options={districtsMultiSelect} value={selectedDistricts} onChange={setSelectedDistricts} />
                                                        )}
                                                    </div>

                                                    <label className="form-label mt-2">Sale Done By</label>
                                                    <select id="rm-input" className="form-select"
                                                        onChange={(e) => handleRegionalManagerChange(e.target.value)}
                                                        value={selectedRegionalManager || ''}>
                                                        <option value="">Select...</option>
                                                        {rmOptions.map((o, i) => (
                                                            <option key={i} value={o.value}>{o.label}</option>
                                                        ))}
                                                    </select>

                                                    <label className="form-label mt-2">Mandal</label>
                                                    <input type="text" id="mandal-input"
                                                        value={selectedMandals[selectedMandals.length - 1] || ''}
                                                        className="form-control" maxLength="50" onChange={handleMandalSelect} />

                                                    <label className="form-label mt-2">Village</label>
                                                    <input type="text" id="village-input"
                                                        value={selectedVillages[selectedVillages.length - 1] || ''}
                                                        className="form-control" maxLength="50" onChange={handleVillageSelect} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer mt-3">
                                        <button type="reset" className="btn btn-secondary" data-bs-dismiss="modal" onClick={clearFilters}>Clear</button>
                                        <button type="button" className="btn btn-primary" data-bs-dismiss="modal"
                                            onClick={() => applyFilter()} disabled={isDisableApply}>Apply</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Data table */}
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 order-0 order-md-1">
                                <div className="card mt-2" style={{ opacity: loading ? 0.5 : 1 }}>
                                    <div>
                                        {!loading && !tableloading && membersData.length === 0 && (
                                            <div style={{ textAlign: 'center', padding: '20px' }}>
                                                <h5 className="text-danger">There are no records to display.</h5>
                                            </div>
                                        )}

                                        {!loading && !tableloading && membersData.length > 0 && (
                                            <CommonTables
                                                tableHeads={tableHeads}
                                                tableData={tableElements}
                                                perPage={perPage}
                                                currentPage={currentPage}
                                                perPageChange={handlePerPageChange}
                                                pageChange={handlePageChange}
                                                totalCount={totalCount}
                                            />
                                        )}

                                        <Snackbar
                                            open={snackbarOpen}
                                            autoHideDuration={3000}
                                            onClose={handleSnackbarClose}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        >
                                            <Alert onClose={handleSnackbarClose} severity="success">
                                                {snackbarMessage}
                                            </Alert>
                                        </Snackbar>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Call Log Modal */}
                        <Modal
                            isOpen={isModalOpen}
                            onRequestClose={() => {
                                setIsModalOpen(false);
                                setCallLogMemberId(undefined);
                                setIsFormVisible(false);
                                setFormData(initialFormData);
                                setFormError({});
                            }}
                            ariaHideApp={false}
                            style={{
                                overlay: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
                                content: {
                                    position: 'relative',
                                    width: '70%',
                                    maxHeight: '90vh',
                                    margin: 'auto',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    overflow: 'auto',
                                    left: window.innerWidth > 1100 ? 120 : 0,
                                    right: window.innerWidth > 1100 ? 100 : 0,
                                    top: 70
                                },
                            }}
                        >
                            <>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
                                    <button
                                        style={{ border: '0px', backgroundColor: "transparent" }}
                                        onClick={() => {
                                            setIsModalOpen(false);
                                            setCallLogMemberId(undefined);
                                            setIsFormVisible(false);
                                            setFormData(initialFormData);
                                            setFormError({});
                                        }}
                                    >
                                        <i style={{ height: "30px", width: "30px" }} className="fa-regular fa-circle-xmark"></i>
                                    </button>
                                </div>
                                <div>{showCallLog()}</div>
                            </>
                        </Modal>
                    </div>

                    {/* MOC Modal */}
                    <div className="modal fade" id="exLargeModal" tabIndex="-1" aria-hidden="true" aria-labelledby="exampleModalLabel4">
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title" id="exampleModalLabel4">Membership Certificate</h4>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                {selectedView && (
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="mb-4">
                                                    <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center">
                                                        <div className="flex-grow-1">
                                                            {selectedView && selectedView.ProductsId !== 0 ? (
                                                                selectedView.MembershipCertificate && selectedView.MembershipCertificate.length > 0 ? (
                                                                    <div className="user-profile-info">
                                                                        <p>Membership certificate already exists for member</p>
                                                                        <p>You can download certificate or ReGenerate it</p>
                                                                    </div>
                                                                ) : (
                                                                    <div className="user-profile-info">
                                                                        <p>Member has purchased products</p>
                                                                        <p>Please Generate Membership certificate here</p>
                                                                    </div>
                                                                )
                                                            ) : (
                                                                <div className="user-profile-info">
                                                                    <p>No products purchased yet.</p>
                                                                    <p>Kindly, purchase products to generate Membership certificate</p>
                                                                </div>
                                                            )}
                                                            {selectedView && selectedView.ProductsId !== 0 && (
                                                                selectedView.MembershipCertificate && selectedView.MembershipCertificate.length > 0 ? (
                                                                    <div className="d-flex flex-row justify-content-end gap-2">
                                                                        <button className="btn btn-secondary" onClick={downloadMOC}>Download MOC</button>
                                                                        <button className="btn btn-primary" onClick={generateMOC}
                                                                            style={{ minWidth: '150px', minHeight: '40px' }} disabled={mocLoading}>
                                                                            {mocLoading
                                                                                ? <div className="spinner-border text-white" role="status"><span className="sr-only">Loading...</span></div>
                                                                                : 'ReGenerate MOC'}
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex flex-row justify-content-end gap-2">
                                                                        <button className="btn btn-primary" onClick={generateMOC}
                                                                            style={{ minWidth: '150px', minHeight: '40px' }} disabled={mocLoading}>
                                                                            {mocLoading
                                                                                ? <div className="spinner-border text-white" role="status"><span className="sr-only">Loading...</span></div>
                                                                                : 'Generate MOC'}
                                                                        </button>
                                                                    </div>
                                                                )
                                                            )}
                                                            {mocError && mocError.length > 0 && <p className="text-danger text-end mt-3 mb-0">{mocError}</p>}
                                                            {mocSuccess && mocSuccess.length > 0 && <p className="text-success text-end mt-3 mb-0">{mocSuccess}</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}